<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        <span> داشبورد گروه کالایی در بازه </span>
        <span>{{ startDate.replaceAll('-', '/') }}</span><span> تا </span><span> {{
          endDate.replaceAll('-', '/')
        }}</span>
        <template v-slot:action>
          <q-btn roun flat icon="print" @click="loadReport" />
          <q-btn round flat icon="close" v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section>
      <q-table
          :data="items"
          flat
          :style="!$q.screen.lt.md?'max-width: 800px':''"
          row_key="Group_ID"
          wrap-cells
          :columns="columns"
          :rows-per-page-options="[0]"
          :hide-header="$q.screen.lt.md">
        <template v-slot:body="props">
          <tr class="my-class" v-if="!$q.screen.lt.md">
            <td style="min-width: 150px" class="text-bold">
              {{props.row.Group_Name}}
            </td>
            <td class="text-center">
              <q-chip square color="teal" text-color="white"
                      v-if="$store.state.roles.some(v=>['admin','see_profit'].includes(v)) && props.row.BuyG_DayPrice"
                      :label="props.row.BuyG_DayPrice.toLocaleString()"/>
            </td>
            <td class="text-center">
              <q-chip square color="green" text-color="white" :label="props.row.SaleG_TotalPricePure.toLocaleString()"/>
            </td>
            <td class="text-center">
              <q-chip dir="ltr" square :color="props.row.DiffPrice>=0?'deep-orange':'red-10'" text-color="white"
                      v-if="$store.state.roles.some(v=>['admin','see_profit'].includes(v))"
                      :label="props.row.DiffPrice.toLocaleString()"/>
            </td>
            <td class="text-center">
              <q-chip dir="ltr" square
                      :color="props.row.DiffBuyLastPrice>=0?'deep-orange':'red-11'" text-color="white"
                      v-if="$store.state.roles.some(v=>['admin','can_see_last_buy_price_by_sale_price_in_yearly_dashboard'].includes(v)) && props.row.DiffBuyLastPrice"
                      :label="props.row.DiffBuyLastPrice.toLocaleString()"/>
            </td>
          </tr>
          <tr :props="props" class="my-class" v-if="$q.screen.lt.md">
            <td>
              <q-card class="shadow-5">
                <q-card-section class="no-padding">
                  <q-chip color="indigo" text-color="white" :label="props.row.Group_Name"/>
                </q-card-section>
                <q-card-section class="no-padding">
                  <q-chip v-if="$store.state.roles.some(v=>['admin','see_profit'].includes(v))" square label="خرید">
                    <q-badge size="sm" square color="teal" text-color="white"
                             :label="props.row.BuyG_DayPrice.toLocaleString()"/>
                  </q-chip>
                  <q-space/>
                  <q-chip square label="فروش">
                    <q-badge size="sm" square color="green" text-color="white"
                             :label="props.row.SaleG_TotalPricePure.toLocaleString()"/>
                  </q-chip>
                  <q-space/>
                  <q-chip square label="اختلاف خرید و فروش">
                    <q-badge v-if="$store.state.roles.some(v=>['admin','see_profit'].includes(v))"
                             size="sm" dir="ltr" square :color="props.row.DiffPrice>=0?'deep-orange':'red-10'"
                             text-color="white" :label="props.row.DiffPrice.toLocaleString()"/>
                  </q-chip>
                  <q-space/>
                  <q-chip square label="اختلاف خرید اصلی و فروش">
                    <q-badge v-if="$store.state.roles.some(v=>['admin','can_see_last_buy_price_by_sale_price_in_yearly_dashboard'].includes(v)) && props.row.DiffBuyLastPrice"
                             size="sm" dir="ltr" square :color="props.row.DiffBuyLastPrice>=0?'deep-orange':'red-10'"
                             text-color="white" :label="props.row.DiffBuyLastPrice.toLocaleString()"/>
                  </q-chip>
                </q-card-section>
              </q-card>
            </td>
          </tr>
        </template>
      </q-table>
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "GoodsGroupDashboard",
  props: {
    startDate: {
      type: String,
      required: true
    },
    endDate: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      items: [],
      columns: [
        {
          name: 'Group_Name',
          required: true,
          label: 'گروه کالا',
          align: 'center',
          field: row => row.Group_Name,
          format: val => `${val}`,
          sortable: true
        },
        {
          name: 'BuyG_DayPrice',
          required: true,
          label: 'مبلغ خرید',
          align: 'center',
          field: row => row.BuyG_DayPrice,
          format: val => `${val}`,
          sortable: true
        },
        {
          name: 'SaleG_TotalPricePure',
          required: true,
          label: 'مبلغ فروش',
          align: 'center',
          field: row => row.SaleG_TotalPricePure,
          format: val => `${val}`,
          sortable: true
        },
        {
          name: 'DiffPrice',
          required: true,
          label: 'اختلاف خرید و فروش',
          align: 'center',
          field: row => row.DiffPrice,
          format: val => `${val}`,
          sortable: true
        },
        {
          name: 'DiffBuyLastPrice',
          required: true,
          label: 'اختلاف خریداصلی و فروش',
          align: 'center',
          field: row => row.DiffBuyLastPrice,
          format: val => `${val}`,
          sortable: true
        },
      ],
    }
  },
  methods: {
    ...mapActions({
      getData: 'Products/getGoodsGroupDashBoard'
    }),
    async loadReport(){
      await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/گزارشات مرتبط با کالا/گزارش فروش کالاهای یک گروه بر اساس بازه زمانی خاص/?rs:Format=PDF&StartDate=${this.startDate.replaceAll('-','/')}&EndDate=${this.endDate.replaceAll('-','/')}&rc:Parameters=False&rc:Zoom=Page Width`)
    }
  },
  created() {
    this.getData({
      startDate: this.startDate,
      endDate: this.endDate
    }).then((res) => {
      this.items = res
    })
  }
}
</script>

<style scoped>

</style>